<template>
    <v-container>
        <message-component 
            id="message" 
            v-model="isMessage" 
            :success="success"
        >{{ message }}</message-component>
        <v-container>
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">
                    IPアドレスによるアクセス制限の設定
                </v-col>
            </v-row>
        </v-container>
        <v-row class="pl-4">
            <v-col cols="auto">
                <v-alert
                    text
                    type="info"
                    class="mb-0"
                >
                    DX-Signへのアクセスを許可するIPアドレスを設定できます。<br>
                    接続元によりアクセスを制限しない場合は、設定しないでください。
                </v-alert>
            </v-col>
        </v-row>
        <v-row class="pl-4">
            <v-col cols="auto">
                <p class="red--text font-weight-bold mb-0">
                    現在のIPアドレス[ {{ current_ip }} ]を含めてください。
                </p>
                <p class="mb-0">
                    入力例）192.0.2.123、192.0.2.0/24
                </p>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col 
                xl="8" lg="8" md="8" sm="6" xs="12" 
                offset-xl="2" offset-lg="2" offset-md="1" offset-sm="0" offset-xs="0"
                class="align-self-end"
            >
                <v-pagination
                    v-if="items.length > 10"
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
            </v-col>
            <v-col 
                xl="2" lg="2" md="3" sm="6" xs="12" 
                class="text-right pr-10 pt-0"
            >
                <v-btn 
                    color="orange" 
                    class="white--text" 
                    @click="addItem"
                >
                    追加
                </v-btn>
            </v-col>
        </v-row>
        <v-container>
            <v-data-table
                :headers="headers"
                :items="items"
                :page.sync="indexInfo.page"
                :items-per-page="indexInfo.itemsPerPage"
                @page-count="indexInfo.pageCount = $event"
                hide-default-footer
                no-data-text="設定されたIPアドレスはありません"
            >
                <template v-slot:item.actions="{ item }">
                    <v-btn 
                        color="blue" 
                        class="white--text mr-4" 
                        @click="editItem(item)"
                    >
                        編集
                    </v-btn>
                    <v-btn 
                        color="blue-grey" 
                        class="white--text" 
                        @click="deleteItem(item)"
                    >
                        削除
                    </v-btn>
                </template>
                
            </v-data-table>
        </v-container>
        
        <ip-address-whitelist-dialog-component
            v-if="dialog" 
            :dialog.sync="dialog" 
            :item="{id: currentItem.id, ip_address: currentItem.ip_address, note: currentItem.note}"
            @success="getWhitelist" 
            @error="error"
        ></ip-address-whitelist-dialog-component>
        
        <delete-dialog-component 
            v-if="deleteDialog" 
            :deleteDialog.sync="deleteDialog" 
            :item="{id: currentItem.id, table: '/documents/ip-address-whitelist/delete/'}" 
            @success="getWhitelist" 
            @error="error"
        >
            <template v-slot:title>{{ currentItem.ip_address }} を削除しますか？</template>
            <template v-slot:ok-btn>削除</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
    </v-container>
</template>

<script>
    import IpAddressWhitelistDialogComponent from "./IpAddressWhitelistDialogComponent";
    export default {
        data() {
            return {
                current_ip: '',
                dialog: false,
                deleteDialog: false,
                headers: [
                    {
                        text: 'IPアドレス',
                        align: 'start',
                        width: 30,
                        sortable: false,
                        value: 'ip_address'
                    },
                    { 
                        text: 'メモ', 
                        sortable: false,
                        width: 40,
                        value: 'note' 
                    },
                    { 
                        text: '', 
                        align: 'end',
                        sortable: false,
                        width: 30,
                        value: 'actions' 
                    },
                ],
                indexInfo: {
                    page: 1,
                    pageCount: 0,
                    itemsPerPage: 10
                },
                items: [],
                message: null,
                props: [],
                success: false,
            };
        },
        components: {
            'ip-address-whitelist-dialog-component': IpAddressWhitelistDialogComponent
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
        methods: {
            addItem() {
                this.dialog = true;
                this.currentItem = '';
            },
            editItem(item) {
                this.dialog = true;
                this.currentItem = item;
            },
            error(message) {
                this.success = false;
                this.message = message;
            },
            deleteItem(item) {
                this.deleteDialog = true;
                this.currentItem = item;
            },
            getWhitelist(message) {
                axios.get('/documents/ip-address-whitelist/get').then(res => {
                    this.items = res.data.whitelist;
                    this.current_ip = res.data.request_ip;
                    this.success = true;
                    this.message = message;
                }).catch(res => {
                    this.success = false;
                    this.message = "取得処理に失敗しました";
                });
            },
        },
        mounted() {
            this.getWhitelist();
        },
    };
</script>

<style scoped>
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }
</style>